module.exports = __webpack_public_path__ + "static/media/Gold-hoops_thumb.fd06f521.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Gold-hoops_thumb.png
// module id = 236
// module chunks = 0